
const getQuestion = ( entry ) => {
  // For switch checkboxes, the question is the first option's label
  if (entry.tag === 'boxes' && entry.attributes?.type === 'switch') {
    return entry.attributes.options[0].label;
  }
  // For text inputs and radio buttons, the question is the entry label
  return entry.label;
}

const getValue = ( entry, stateEntry ) => {
  if (entry.tag === 'boxes' && entry.attributes?.type === 'switch') {
    return stateEntry.value === 'yes';
  }
  // text inputs and radio buttons store the value as a string
  return stateEntry.value;
}

const isDataField = ( key, entry ) => {
  if (key.startsWith('X')) return false;
  if (key.startsWith('guard')) return false;
  return true;
}

// slice is store.forms.forms[label]
const simpleFormExtractor = ( slice ) =>
  Object.entries( slice.entries )
  .filter(([k,v]) => isDataField(k, v))
  .map( ([k,v]) => ({
                      id: k,
                      query: getQuestion(v),
                      answer: getValue( v, slice.state[k])
                    }))

export default simpleFormExtractor;